angular.module('impactx.rfxsupplier').component('ixRfxSupplierDescription', {
        bindings: {
            description: '<',
            comments: '<',
            isClosed: '<',
            trns: '<'
        },
        controller: 'RFXSupplierDescriptionCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-description.html'
    }
);